import DB from "../../utils/db.json";
import MetaTagsSEO from "../../utils/metaTagsFunction";
import DownloadCatalogues from "./components/downloadCatalogues";
import InnerBannerWrapper from "./components/innerBannerWrapper";

function Catalogues() {
  return (
    <>
      <MetaTagsSEO metaTags={DB.catalogue} title="Catalogue Download - JB Glass." />

      <InnerBannerWrapper />

      <DownloadCatalogues />
    </>
  );
}

export default Catalogues;
